import Vue from "vue";
import Cursus from 'cursus';

Vue.use(Cursus);
Vue.component('cursus', () => ({
    component: import(/* webpackChunkName: 'cursus' */'cursus/src/component'),
    loading: {
        template: '<div><slot /></div>',
    },
    delay: 0,
}));
Vue.component('cursus-account-form', () => ({
    component: import(/* webpackChunkName: 'cursus-account-form' */'cursus/src/components/AccountForm.vue'),
    loading: {
        template: '<div><slot /></div>',
    },
    delay: 0,
}))
